import { writable } from "svelte/store";

type Direction = "left" | "right";
export type TabBlock = Map<
  string,
  { activeTab: string; tabToDelete: string; clickDirection: Direction }
>;

const initialState = new Map();

const tabBlockStore = () => {
  const { subscribe, update } = writable<TabBlock>(initialState);

  return {
    subscribe,
    setActiveTab: (blockId: string, activeTab: string, clickDirection: Direction) => {
      update((state) => {
        const block = state.get(blockId)!;
        state.set(blockId, { ...block, activeTab, clickDirection });
        return state;
      });
    },
    setTabToDelete: (blockId: string, tabToDelete: string) => {
      update((state) => {
        const block = state.get(blockId)!;
        state.set(blockId, { ...block, tabToDelete });
        return state;
      });
    },
    removeTabBlock: (blockId: string) => {
      update((state) => {
        state.delete(blockId);
        return state;
      });
    },
  };
};

export const tabBlocks = tabBlockStore();
